import React from 'react';

const StatCard = ({ icon: Icon, value, label }) => (
  <div className="bg-white p-6 border border-stone-200">
    <Icon className="w-8 h-8 text-stone-400 mb-2" />
    <div className="text-2xl font-bold text-stone-900">{value}</div>
    <div className="text-stone-500 text-sm">{label}</div>
  </div>
);

export default StatCard;
